document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-vienli-tabs]').forEach(function (root) {
    root.querySelectorAll('[data-vienli-tab-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-vienli-tab-btn');
        root.querySelectorAll('[data-vienli-tab-btn]').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        root.querySelectorAll('[data-vienli-tab-panel]').forEach(function (p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        root.querySelector('[data-vienli-tab-panel="' + id + '"]').classList.add('is-active');
      });
    });
  });
});
